import { FC, Fragment, useEffect } from 'react';
import { Redirect, Switch, useHistory } from 'react-router-dom';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { CampaignsV2 } from './v2/CampaignsV2';

const LegacyWhatsappCreateRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace(RouteConstants.createCampaignWhatsapp);
  }, [history]);

  return null;
};

export const CampaignsRouter: FC = () => (
  <Fragment>
    <Switch>
      <PrivateRoute
        exact
        path={RouteConstants.campaigns}
        component={() => {
          return <Redirect to={RouteConstants.whatsappCampaigns} />;
        }}
      />
      <PrivateRoute
        exact
        path={RouteConstants.createCampaignWhatsappLegacy}
        component={LegacyWhatsappCreateRedirect}
      />
      <PrivateRoute exact path={`${RouteConstants.campaigns}/:tab(whatsapp|sms|email)`} component={CampaignsV2} />
      <PrivateRoute path={`${RouteConstants.campaigns}/whatsapp/campaigns`} component={CampaignsV2} />
      <PrivateRoute path={`${RouteConstants.campaigns}/whatsapp/templates`} component={CampaignsV2} />
      <PrivateRoute path={`${RouteConstants.campaigns}/whatsapp/packages`} component={CampaignsV2} />
      <PrivateRoute path={`${RouteConstants.campaigns}/sms`} component={CampaignsV2} />
      <PrivateRoute path={`${RouteConstants.campaigns}/email`} component={CampaignsV2} />
      <Redirect to={RouteConstants.whatsappCampaigns} />
    </Switch>
  </Fragment>
);
